import React, { useState, useEffect } from "react";
import { usePlayerContext } from "../../../context/PlayerContext";
import ModuleMobile from "../ModuleMobile";
import "./style.scss";

const OFFSET_TOP = 100;

const ModuleMobileWidget = ({
    moduleRef,
    commentsEnabled,
    questionsEnabled,
    currentModule,
    setCurrentModule,
    handleOpenQuestionWriteForm,
    isFullscreen = false,
    settings,
    pollsEnabled,
    modules,
    isClose,
    isWidgetBottomSidebar,
}) => {
    const className = 'side-module-mobile-widget';
    const [isOpen, setIsOpen] = useState(isFullscreen);

    const { tabletView } = usePlayerContext();

    useEffect(() => {
        return () => {
            const playerBlock = document.getElementById('player-block');
            const streamTabsElement = document.getElementById('stream-tabs');
            const sideModule = document.getElementById('side-module-mobile-widget');

            if (playerBlock) {
                playerBlock.style.position = "";
                playerBlock.style.top = "";
                playerBlock.style.left = "";
                playerBlock.style.right = "";
            }

            if (streamTabsElement) {
                streamTabsElement.style.position = "";
                streamTabsElement.style.top = "";
                streamTabsElement.style.left = "";
                streamTabsElement.style.right = "";
            }

            if (sideModule) {
                sideModule.style.height = `460px`;
            }
        }
    }, []);

    const onOpen = (isOpen) => {
        const playerBlock = document.getElementById('player-block');
        const sideModule = document.getElementById('side-module-mobile-widget');
        const streamTabsElement = document.getElementById('stream-tabs');

        if (!playerBlock || !sideModule || isFullscreen) {
            return;
        }

        if (isOpen) {
            playerBlock.style.top = `${5 - playerBlock.offsetHeight - OFFSET_TOP}px`;
            playerBlock.style.left = 0;
            playerBlock.style.right = 0;
            playerBlock.style.position = 'fixed';

            sideModule.style.height = `${sideModule.offsetHeight + playerBlock.offsetHeight}px`;

            if (streamTabsElement) {
                streamTabsElement.style.top = `${- streamTabsElement.offsetHeight - OFFSET_TOP}px`;
                streamTabsElement.style.position = 'fixed';
            }
        } else {
            playerBlock.style.position = "";
            playerBlock.style.top = "";
            playerBlock.style.left = "";
            playerBlock.style.right = "";

            sideModule.style.height = `${sideModule.offsetHeight - playerBlock.offsetHeight}px`;

            if (streamTabsElement) {
                streamTabsElement.style.position = "";
                streamTabsElement.style.top = "";
            }
        }

        setIsOpen(status => !status);
    };

    return (
        <div className={`${className} ${isWidgetBottomSidebar ? `${className}--bottom` : ''}`} id="side-module-mobile-widget">
            <ModuleMobile 
                isFullscreen={isWidgetBottomSidebar ? !tabletView : isFullscreen}
                moduleRef={moduleRef}
                commentsEnabled={commentsEnabled}
                questionsEnabled={questionsEnabled}
                pollsEnabled={pollsEnabled}
                currentModule={currentModule}
                settings={settings}
                setCurrentModule={setCurrentModule}
                handleOpenQuestionWriteForm={handleOpenQuestionWriteForm}
                onOpen={onOpen}
                isOpen={isOpen}
                isClose={isWidgetBottomSidebar ? tabletView : isClose}
                modules={modules}
            />
        </div>
    );
}

export default ModuleMobileWidget;
